export const createElevation = () => ({
  dropdown: '0px 1px 6px 2px rgba(0, 0, 0, 0.14)',
});
